export enum Alert {
	WAREHOUSE_DELAY = 'warehouse_delay',
	TRANS_RETAINED_CUSTOMS = 'trans_retained_customs',
	TRANS_ABSENT = 'trans_absent',
	TRANS_WRONG_ADDR = 'trans_wrong_addr',
	TRANS_LOST = 'trans_lost',
	TRANS_PENDING_PICKUP = 'trans_pending_pickup',
	TRANS_DELAY = 'trans_delay',
}
